import { vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = {
  key: 0,
  class: "field-error"
}
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = {
  key: 0,
  class: "field-error"
}
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "form-consent" }
const _hoisted_7 = {
  key: 0,
  class: "field-error consent-error"
}
const _hoisted_8 = {
  key: 1,
  class: "form-error"
}
const _hoisted_9 = {
  key: 2,
  class: "form-success"
}
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    class: "contact-form",
    onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.contact_name) = $event)),
        type: "text",
        placeholder: "Ваше имя *",
        class: _normalizeClass(["form-input", { 'input-error': _ctx.errors.contact_name }])
      }, null, 2), [
        [_vModelText, _ctx.form.contact_name]
      ]),
      (_ctx.errors.contact_name)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.errors.contact_name), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.phone) = $event)),
        type: "tel",
        placeholder: "Телефон *",
        class: _normalizeClass(["form-input", { 'input-error': _ctx.errors.phone }])
      }, null, 2), [
        [_vModelText, _ctx.form.phone]
      ]),
      (_ctx.errors.phone)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.errors.phone), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.comment) = $event)),
        placeholder: "Комментарий",
        class: "form-input form-textarea",
        rows: "3"
      }, null, 512), [
        [_vModelText, _ctx.form.comment]
      ])
    ]),
    _createElementVNode("label", _hoisted_6, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.consent) = $event)),
        type: "checkbox"
      }, null, 512), [
        [_vModelCheckbox, _ctx.form.consent]
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("span", null, "Даю согласие на обработку персональных данных и соглашаюсь с политикой конфиденциальности", -1))
    ]),
    (_ctx.errors.consent)
      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.errors.consent), 1))
      : _createCommentVNode("", true),
    (_ctx.submitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.submitError), 1))
      : _createCommentVNode("", true),
    (_ctx.submitSuccess)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Спасибо! Мы свяжемся с вами в ближайшее время."))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      type: "submit",
      class: "btn-submit",
      disabled: _ctx.submitting
    }, _toDisplayString(_ctx.submitting ? "Отправка..." : "Отправить"), 9, _hoisted_10)
  ], 32))
}